export default "__VITE_ASSET__htYEt8CU__"